export default {
  SET_LOADING(state, payload) {
    state.loading = payload
  },
  SET_ERROR(state, payload) {
    state.error = payload
  },
  SET_MAP_VISIBLE(state, payload) {
    state.mapVisible = payload
  },
  SET_SETTINGS(state, payload) {
    state.settings = payload
  },
  SET_DISTRICTS(state, payload) {
    state.districts = payload
  },
  SET_SEASONS(state, payload) {
    state.seasons = payload
  },
  SET_LOCATIONS(state, payload) {
    state.locations = payload
  },
  SET_PRODUCTIONS(state, payload) {
    state.productions = payload
  },
  SET_FILTERS(state, payload) {
    state.filters = payload
  },
  SET_FILTER(state, { filter, value }) {
    state.filters[filter] = value
  },
  SET_HIGHLIGHTED_LOCATION(state, payload) {
    state.highlightedLocation = payload
  }
}
